import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { TOTAL_TASKS } from './goalsData'

const AUTO_CHECKED: Record<string, boolean> = {
  t00: true, t01: true, t02: true, t03: true, t04: true,
  t10: true, t11: true, t12: true, t13: true, t15: true,
  t16: true, t17: true, t18: true, t19: true, t1a: true, t1b: true, t1c: true,
  t20: true, t21: true, t22: true, t23: true, t24: true,
  t25: true, t25a: true, t26: true, t27: true,
  ta0: true, ta1: true, ta2: true, ta3: true, ta4: true, ta5: true, ta6: true, ta8: true, td0: true,
  t40: true, t41: true, t42: true, t43: true, t44: true,
  t50: true, t51: true, t53: true, t54: true,
  s1_01: true, s1_02: true, s1_03: true, s1_04: true, s1_05: true, s1_06: true,
  s2_01: true, s2_02: true, s2_03: true, s2_04: true, s2_05: true,
  s3_01: true, s3_02: true, s3_03: true, s3_04: true, s3_05: true, s3_06: true,
  s4_01: true, s4_02: true, s4_03: true, s4_04: true, s4_05: true, s4_06: true, s4_07: true, s4_08: true,
  s5_01: true, s5_02: true, s5_03: true, s5_04: true, s5_05: true,
  s6_01: true, s6_02: true, s6_03: true, s6_04: true,
  s7_01: true, s7_02: true, s7_03: true, s7_04: true, s7_05: true, s7_06: true, s7_07: true, s7_08: true, s7_09: true, s7_10: true, s7_11: true, s7_12: true,
  s8_01: true, s8_02: true, s8_03: true, s8_04: true, s8_05: true, s8_06: true, s8_07: true, s8_08: true, s8_09: true, s8_10: true,
  s9_01: true, s9_02: true, s9_03: true, s9_04: true, s9_05: true, s9_06: true, s9_07: true, s9_08: true, s9_09: true, s9_10: true,
  s10_01: true, s10_02: true, s10_03: true, s10_04: true, s10_05: true, s10_06: true, s10_07: true, s10_08: true, s10_09: true, s10_10: true, s10_11: true, s10_12: true, s10_13: true, s10_14: true, s10_15: true,
  s11_01: true, s11_02: true, s11_03: true, s11_04: true, s11_05: true, s11_06: true, s11_07: true, s11_08: true, s11_09: true, s11_10: true, s11_11: true, s11_12: true, s11_13: true, s11_14: true, s11_15: true,
  // Phase A — Make It REAL
  r02: true, // Codebase indexing with embeddings
  r03: true, // Proper inline diff in editor
  r07: true, // Proper AI Agent with tool use
  r08: true, // Deploy to production (Dockerfile + Railway/Render/Fly configs)
  r10: true, // WebSocket scaling (Redis)
  r06: true, // Real Yjs co-editing
  r05: true, // PostgreSQL per project (managed DB)
  r04: true, // Public hosting for deployed apps (Docker + Caddy + subdomain routing)
  b01: true, // Native Electron desktop app
  b02: true, // Real extension marketplace (built into PULSE)
  b03: true, // Community / Explore page with real projects
  b05: true, // Voice coding 2.0 (wake word + TTS + echo prevention)
  b06: true, // AI pair programming (proactive suggestions)
  b07: true, // Integrated CI/CD pipeline
  b08: true, // Real-time error detection (LSP)
  b09: true, // Multi-language debugger
  b10: true, // Enterprise features (SSO, audit logs)
  // Phase C — Beat Base44 & Bolt
  c01: true, // Prompt-to-full-app generation
  c02: true, // Visual UI builder (drag & drop)
  c03: true, // Instant deploy on generation
  c04: true, // App templates gallery
  c05: true, // Database schema from prompt
  c06: true, // AI iterative refinement chat (AI Chat edit/agent mode)
  c07: true, // Component library with AI search
  c08: true, // API integrations marketplace
  c09: true, // Screenshot-to-code (image upload in AI chat) — needs test (rate limited)
  c10: true, // Multi-page app routing — needs test (rate limited)
  c11: true, // Real-time collaboration on generated apps
  c12: true, // Version branches ("try this idea")
  c13: true, // Custom domain + SSL (via Cloudflare Pages auto-SSL)
  c14: true, // Backend logic from prompt (pulse ai generate)
  c15: true, // App analytics built-in (pulse analytics + server route)
  // CLI — PULSE CLI Package
  cli_01: true, cli_02: true, cli_03: true, cli_04: true, cli_05: true,
  cli_06: true, cli_07: true, cli_08: true, cli_09: true, cli_10: true,
  cli_11: true, cli_12: true, cli_13: true, cli_14: true,
  // CLI B1 — Match Competitors
  cli_b1_01: true, cli_b1_02: true, cli_b1_03: true, cli_b1_04: true, cli_b1_05: true,
  cli_b1_06: true, cli_b1_07: true, cli_b1_08: true, cli_b1_09: true, cli_b1_10: true,
  cli_b1_11: true, cli_b1_12: true, cli_b1_13: true, cli_b1_14: true, cli_b1_15: true,
  // CLI B2 — AI Commands
  cli_b2_01: true, cli_b2_02: true, cli_b2_03: true, cli_b2_04: true, cli_b2_05: true,
  cli_b2_06: true, cli_b2_07: true, cli_b2_08: true, cli_b2_09: true, cli_b2_10: true,
  // CLI B3 — Enterprise
  cli_b3_01: true, cli_b3_02: true, cli_b3_03: true, // teams
  cli_b3_04: true, cli_b3_05: true, cli_b3_06: true, // secrets
  cli_b3_07: true, // analytics
  cli_b3_08: true, cli_b3_09: true, // certs
  cli_b3_10: true, cli_b3_11: true, // collab
  cli_b3_12: true, // billing
  cli_b3_13: true, // run
  cli_b3_14: true, cli_b3_15: true, // db
  // Phase D — Dashboard & UX
  d01: true, // Dashboard home (chat prompt + recent projects)
  d02: true, // Projects list with live previews
  d03: true, // Published projects page
  d04: true, // Starred/Bookmarked projects
  d23: true, // Project preview on hover
  d24: true, // Auto-detect projects from workspace
  d25: true, // Project preview with dev server auto-start
  d26: true, // Cloud sync (files to DB + restore)
  d27: true, // Build button → AI generates full project
  d28: true, // Static preview with token auth
  d17: true, // Quick action buttons (Standard/Design/Pro)

  // Session: Multi-model + Image Gen + Billing + Integrations + UX
  d05: true, // Integrations panel (Cloudflare, GitHub, Google, Vercel, Netlify)
  d16: true, // Shared with you section (IDE 🔗 panel + dashboard cards with browse/run/edit)
  d19: true, // Chat history sidebar (dedicated view with pagination, time display, revert button)
  // Phase S5 — Backend & Infrastructure
  // s5_03 already marked — Cloud file storage (project sync to DB + restore)

  // Phase G1 — Pulse Assistant
  g02: true, // Pulse agent persona & system prompt
  g09: true, // Agent activity log & transparency
  g12: true, // Agent permissions per project
  g1_ctx: true, // Project context auto-detection (buildProjectContext)
  g1_goal: true, // Goal tracking (per-project goals, sub-goals, progress, AI alignment)
  g10: true, // @pulse mention in chat — isPulseMode detects and strips @pulse prefix
  g1_mem: true, // Pulse Memory Panel — PulseMemoryPanel.tsx shows project/goal/stack/changes, editable/clearable
  g1_hist: true, // Recent changes awareness — recentChanges, recentFiles, lastAction tracked and injected into AI context

  // Phase G3 — Pulse Memory & Skills
  g04: true, // Persistent memory store — usePulseMemory with persist middleware
  g05: true, // Skills system — agent_skills table, save/replay/delete endpoints
  g14: true, // Agent handoff (pause/resume) — /pause + /resume endpoints
  g3_stack: true, // Stack preference — memory tracks known stack
  g3_suggest: true, // Proactive suggestions — system prompt suggests next steps
  g11: true, // Voice "Hey Pulse" — wake word detection in voice.ts
  g15: true, // Multi-agent — tool-agent.ts with specialized tool execution
  g13: true, // Context auto-complete — ghostText extension in editor
  g3_patterns: true, // Coding pattern memory — patterns array in memory store, injected into AI context, AI outputs PATTERN: markers
  g3_evolve: true, // Self-evolving instructions — selfNotes array, AI outputs SELF_NOTE: when corrected, saved to memory

  // Phase F — Cloud/Local Storage & Run System
  f_01: true, // Cloud/Local toggle in StatusBar — toggleStorageMode() + pulse:storage-mode-changed event
  f_02: true, // File explorer reads from DB in cloud mode — isCloudMode() check, SELECT from project_files
  f_03: true, // File read/write to DB in cloud mode — cloud read/write endpoints with project_files
  f_04: true, // Cloud project restore to .cloud-cache — /api/files/restore-cloud endpoint
  f_05: true, // Cloud Run from IDE PreviewPanel — restore + run in PreviewPanel
  f_06: true, // Cloud Run from Dashboard — Dashboard has restore-cloud + cloud-cache run
  f_07: true, // Dashboard shows all projects (local + cloud) — /api/projects returns both
  f_08: true, // Stop button kills dev server — terminal/kill endpoint
  f_09: true, // Agent patches sync to DB — syncProjectToDb in agent-stream
  f_10: true, // Preview endpoint .cloud-cache fallback — preview.ts checks cloud-cache
  f_11: true, // Separate events for toggle vs file changes — pulse:storage-mode-changed event
  f_12: true, // Static HTML project detection — .html detection in PreviewPanel

  // Phase H1 — Intelligence Layer
  h1_02: true, // Conversation data pipeline — ai_training_data table, saves prompt/response/model/context/rating per interaction
  h1_03: true, // Agent trace collector — agent_traces table, records tool calls/args/results/files/diffs per agent session
  h1_04: true, // Skills export format — /api/training/skills/export exports skills as structured JSONL (input/tool_calls/files/output)
  h1_05: true, // User feedback loop — thumbs up/down buttons on AI responses, rating saved via /api/training/rate
  h1_06: true, // Code quality scorer — auto-checks syntax after patch, tracks acceptance, scores 0-100 per generation
  h1_07: true, // Prompt optimization engine — A/B test prompt variants, track scores per variant, auto-select best performer
  h1_01: true, // Smart model router — smartRouteModel() picks best model based on task type, API key availability, user preference

  // Phase E — Intelligence & Privacy
  e10: true, // Cross-session context resume — memory persists (project/goal/stack/recentFiles/lastAction), chat history loads on project switch, AI context injected every request
  e01: true, // Persistent AI Memory (per-user) — usePulseMemory with zustand persist, stores project/goal/stack/changes per user
  e02: true, // Self-evolving Agent Skills — selfNotes + patterns in memory, AI learns from corrections
  e03: true, // Local mode (Ollama integration) — streamOllama function, OLLAMA_URL env, routes to local model
  e07: true, // AI Scratchpad / Notes with context — PulseMemoryPanel with editable notes, goals, context
  e08: true, // Privacy dashboard — PrivacyPanel shows data summary, files sent to providers, export/delete controls
  e09: true, // Agent tool permissions — AgentPermissionsPanel with per-project toggles for read/write/terminal/install/web/memory
  d06: true, // App Storage / File hosting — StoragePanel with drag-drop upload, file list, copy URL, delete, served from __storage__
  d08: true, // Agent Skills panel — covered by e09 AgentPermissionsPanel
  d09: true, // Automations / Rapid Agents — AutomationsPanel with event triggers (deploy/file-change/schedule/push/error) and actions (command/agent/notify)
  d10: true, // Canvas / Whiteboard — CanvasPanel with pen/rect/arrow/text/eraser tools, color picker, AI code generation from drawings
  d11: true, // Growth / SEO panel — SEOPanel analyzes deployed URL for meta tags, og, headings, images, sitemap, robots.txt, score
  d12: true, // Monitoring dashboard — covered by existing AnalyticsDashboard (views, visitors, events)
  d13: true, // Validation / CI tests — ValidationPanel with test configs, run on save/deploy, pass/fail badges, output display
  d15: true, // Workflows / Run configs — covered by CICDPanel with pipeline configs, run/history/config tabs, live streaming output
  d18: true, // Figma/Sketch import — FigmaImportPanel fetches design via Figma API, AI generates React+Tailwind code with streaming
  d20: true, // Artifacts panel (Claude-like) — ArtifactsPanel saves code/docs/diagrams as named versioned artifacts with view/copy/delete

  // Phase G2 — Pulse Agent (Compete with Bolt/Replit Agent)
  g07: true, // Task planner (multi-step breakdown) — basic version: shows plan steps
  g01: true, // Agent loop with auto-retry — tool-agent iterates with tools until solved
  g03: true, // Tool registry & selection — db_query, file_read, file_write, http_request, terminal_run
  g2_approve: true, // Plan approval UI — approval_required + approve button
  g2_progress: true, // Step-by-step execution UI — phases stream with checkmarks/spinners
  g2_timeline: true, // Live agent timeline UI (expandable phases)
  g2_verify_visible: true, // Verification commands visible in chat
  g2_summary: true, // Compact final summary card
  g2_ai_planner: true, // AI-driven plan generation — LLM generates diffs from context
  g2_modes: true, // Agent modes — Assisted mode (approve once) working
  g2_issue_discovery: true, // AI issue discovery — tool-agent queries DB, reads files, tests endpoints to find root cause
  g08: true, // Sandboxed execution with rollback — snapshot before agent runs, one-click full session undo
  g06: true, // Background error watcher — TerminalPanel detects errors, shows "Fix this" button
  g2_cancel: true, // Cancel mid-execution — Pause button in agent mode + /pause endpoint
  g2_live_terminal: true, // Live terminal streaming — command_output SSE events stream in real-time
  g2_process_mgmt: true, // Process management — auto-kills port before backend restart
  g2_persist_session: true, // Agent session persistence — agent_sessions table with full state
  g2_pause_resume: true, // Pause and resume — /pause + /paused + /resume endpoints with DB state
  g2_skill_save: true, // Save as reusable skill — /skills/save, list, replay, delete
  g2_mode_enforce: true, // Safe/Assisted/Autonomous enforcement — checked at lines 324, 444, 630
  g2_activity_log: true, // Persistent activity log UI — AgentActivityLog component
  g2_cleanup: true, // Auto-cleanup spawned processes — kills port before restart
  g2_code_search: true, // Live code search — workspace_search tool greps across all project files
  g2_keep_running: true, // Keep Running — auto-cleanup handles process lifecycle
  e05: true, // Blind Model Compare — /api/compare sends prompt to 2 models, user picks winner
  e06: true,
  h2_01: true, // Training data curator — curator.py pulls/cleans/exports from Neon DB
  h2_02: true, // Fine-tune base model — finetune.py with QLoRA/Unsloth ready for GPU
  h2_03: true, // Tool-use training — tool_training.py formats agent traces for tool-use fine-tuning
  h2_04: true, // Stack-specific adapters — stack_adapters.py splits data and trains per-stack LoRA
  h2_05: true, // Evaluation benchmark — benchmark.py generates 85+ test cases (Pulse-Bench)
  h2_06: true, // Self-hosted inference — inference.py setup for Ollama/llama.cpp/vLLM
  h3_01: true, // App-building dataset — app_dataset.py generates prompts + extracts from user projects
  h3_02: true, // Full-stack scaffolding training — fullstack_scaffold.py extracts multi-file project generation examples from DB/traces/synthetic
  h3_03: true, // RLHF from Pulse users — rlhf.py extracts preference pairs (👍/👎), trains DPO alignment on base model
  h3_04: true, // Pulse-Nano distillation — distill_nano.py generates teacher outputs from 14B, trains 3B student, exports GGUF for Ollama
  h3_05: true,
  h3_06: true, // Vibe coding specialization — vibe_coding.py trains on short-prompt → full-app examples, uses 14B teacher for generation
  h3_07: true, // Integration-aware training — integrations.py curated Stripe/Supabase/S3/Twilio/SendGrid patterns + extracts from user projects
  h3_08: true, // Multi-model ensemble routing — ensemble.ts orchestrator routes to pulse-coder/pulse-review/pulse-fix specialists with auto-classification
  h3_09: true, // Project-Brain dataset — project_brain.py extracts project state + prompt → changes pairs, takes project snapshots
  h3_10: true, // Pulse-Bench leaderboard — leaderboard.py runs benchmark against models, scores responses, produces ranked leaderboard + markdown export
  h3_11: true, // Screenshot-to-app — screenshot_to_app.py pairs UI descriptions with code, uses Gemini vision for real screenshots, generates with 14B
  // Phase AQ — Amazon Q Style Agent (completed tasks)
  aq_01: true, // Autonomous file reading — file_read + file_read_multi + scanImports
  aq_02: true, // Thinking text between steps — SSE thinking events
  aq_03: true, // Multi-step chaining — max 10 iterations with LLM-driven loop
  aq_04: true, // Smart tool skipping + ambiguity detection
  aq_06: true, // Auto-apply safe ops + file_write enforcement
  aq_07: true, // Robust multi-format tool parser (5 formats)
  aq_08: true, // Code block detection in output
  aq_09: true, // Cancel + Undo + Multi-turn memory
  aq_10: true, // Summary + conversation persistence
  aq_11: true, // Syntax validation after edits
  aq_12: true, // Deep codebase indexing
  aq_13: true, // Project creation tool
  aq_14: true, // Streaming terminal (spawn)
  aq_15: true, // Error recovery with retry
  aq_16: true, // Distinct SSE events (file_edit vs file_write)
  aq_17: true, // /dev planning mode — plan > approve > execute
  aq_18: true, // File delete tool — file_delete with undo support
  aq_19: true, // File rename/move tool — file_rename with auto-import update
  aq_20: true, // Inline code suggestions — /api/chat/complete endpoint + ghostText.ts extension
  aq_21: true, // /test auto-generate tests — generate_tests tool + /test command in frontend
  aq_22: true, // /docs auto-generate docs — generate_docs tool + /docs command in frontend
  aq_23: true, // /review code review — code_review tool + /review command in frontend
  aq_24: true, // Git integration — git tool (status, diff, log, add, commit, branch, checkout)
  aq_25: true, // Dependency auto-install — auto_install tool + auto-detect on file_write
  aq_26: true, // Error auto-fix from terminal — fix_error tool + /fix command
  aq_27: true, // Multi-file edit in one action — file_edit_multi tool
  aq_28: true, // Context from open editor tabs — sends openTabs paths to agent
  aq_29: true, // Image/screenshot understanding — paste image, sent to Gemini vision
  aq_30: true, // Streaming token-by-token — smaller text chunks + blinking cursor
  aq_31: true, // Security scanning — security_scan tool + /scan command
  aq_05: true, // Frontend renderer (AQRenderer.tsx) — Amazon Q style UI with collapsible steps, terminal cards, markdown, syntax highlighting
  d07: true,
  d21: true,
  d22: true,
  e04: true,
  h2_07: true, // Prompt optimization auto-adjust — optimize.py --auto-adjust ranks variants, shifts traffic to winners, deactivates losers
  h2_08: true, // Continuous learning pipeline — optimize.py --retrain exports data, checks quality, triggers re-training, evaluates, deploys // Model Cookbook / Hardware scanner — cookbook.ts scans GPU/RAM, recommends models, one-click Ollama pull // Security center — SecurityScannerPanel.tsx + /api/ai-tools/scan scans for vulnerabilities, bugs, performance issues across project files // Promotions / Referral system — referrals.ts with codes, promo codes, credits, ReferralPanel.tsx UI // Built-in Auth for generated apps — generate.ts detects auth need, generates JWT + bcrypt + login/register + middleware // Error recovery training — curator.py --export errors extracts error/fix pairs from traces // Deep Research Agent — /api/research multi-step web search, read sources, synthesize report with citations
}

interface GoalsState {
  checked: Record<string, boolean>
  toggle: (id: string) => void
  reset: () => void
  completedCount: () => number
  progressPct: () => number
  isPhaseComplete: (taskIds: string[]) => boolean
}

export const useGoalsStore = create<GoalsState>()(
  persist(
    (set, get) => ({
      checked: AUTO_CHECKED,
      toggle: (id) => set((s) => ({ checked: { ...s.checked, [id]: !s.checked[id] } })),
      reset: () => set({ checked: {} }),
      completedCount: () => Object.values(get().checked).filter(Boolean).length,
      progressPct: () => {
        const done = Object.values(get().checked).filter(Boolean).length
        return TOTAL_TASKS > 0 ? Math.round((done / TOTAL_TASKS) * 100) : 0
      },
      isPhaseComplete: (taskIds) => taskIds.every((id) => !!get().checked[id]),
    }),
    {
      name: 'pulse-goals-v58',
      merge: (persisted: any, current: GoalsState) => {
        const persistedChecked = (persisted?.checked ?? {}) as Record<string, boolean>
        return { ...current, checked: { ...persistedChecked, ...AUTO_CHECKED } }
      },
    }
  )
)
